import { render, staticRenderFns } from "./PageSignupForm.vue?vue&type=template&id=3255f04f&"
import script from "./PageSignupForm.vue?vue&type=script&lang=js&"
export * from "./PageSignupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports